export enum HeaderType {
  UNAUTHENTICATED_HEADER = 'UNAUTHENTICATED_HEADER',
}
